/**
 * Supported languages resource
 *
 * NOTE: Resources must by default export a function that returns a Promise resolved with an object where the key is the
 * RESOURCE_KEY and value is loaded resource data. Resources can be used to get any resource but are most useful for
 * loading global app resources needed by the app to work properly.
 */
import {fetchAllSupportedLanguages} from 'Language/helper';

export const RESOURCE_KEY = 'supportedLanguages';

/**
 * Resource function
 * @return {Promise<Object<string, any>>} Promise that will resolve with an object where key is the RESOURCE_KEY and
 * value is loaded resource data.
 */
async function resourceFunction() {
	const supportedLanguages = await fetchAllSupportedLanguages();
	return Promise.resolve({[RESOURCE_KEY]: supportedLanguages.filter(l => !l.inactive)});
}

export default resourceFunction;